import { useEffect } from "react";
import { Route, useLocation } from "react-router-dom";
import { Header, Footer, StickyCta } from "@/components/Layout";
import Home from "@/pages/Home";
import { ServicesPage, ServiceDetail } from "@/pages/Services";
import { PsychologistsPage, PsychologistDetail } from "@/pages/Psychologists";
import { MentalHealthPage, TopicDetail, AnswersPage, AnswerDetail } from "@/pages/MentalHealth";
import Assessment from "@/pages/Assessment";
import { ProgramsPage, ProgramDetail } from "@/pages/Programs";
import { FaqPage, LocationPage } from "@/pages/Info";
import Contact from "@/pages/Contact";
import Booking from "@/pages/Booking";
import Legal from "@/pages/Legal";
import AreaPage from "@/pages/Area";
import Expats from "@/pages/Expats";
import { AREAS } from "@/data/areas";
import { trackPageView } from "@/lib/analytics";

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageView(pathname);
    // trackPageView is a stable module-level import
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
  return null;
};

const Shell = ({ lang, children }) => (
  <>
    <Header lang={lang} />
    <main>{children}</main>
    <Footer lang={lang} />
    <StickyCta lang={lang} />
  </>
);

const SEGMENTS = {
  id: { services: "layanan", psychologists: "psikolog", assessment: "asesmen-psikologi", programs: "program", mentalHealth: "kesehatan-mental", answers: "jawaban", faq: "faq", location: "lokasi", contact: "kontak", booking: "buat-janji", privacy: "kebijakan-privasi", terms: "syarat-ketentuan", cancellation: "kebijakan-pembatalan" },
  en: { services: "services", psychologists: "psychologists", assessment: "psychological-assessment", programs: "programs", mentalHealth: "mental-health", answers: "answers", faq: "faq", location: "location", contact: "contact", booking: "book", privacy: "privacy-policy", terms: "terms", cancellation: "cancellation-policy" },
};

export const langRoutes = (lang) => {
  const seg = SEGMENTS[lang];
  return (
    <>
      <Route index element={<Shell lang={lang}><Home lang={lang} /></Shell>} />
      <Route path={seg.services} element={<Shell lang={lang}><ServicesPage lang={lang} /></Shell>} />
      <Route path={`${seg.services}/:slug`} element={<Shell lang={lang}><ServiceDetail lang={lang} /></Shell>} />
      <Route path={seg.psychologists} element={<Shell lang={lang}><PsychologistsPage lang={lang} /></Shell>} />
      <Route path={`${seg.psychologists}/:slug`} element={<Shell lang={lang}><PsychologistDetail lang={lang} /></Shell>} />
      <Route path={seg.assessment} element={<Shell lang={lang}><Assessment lang={lang} /></Shell>} />
      <Route path={seg.programs} element={<Shell lang={lang}><ProgramsPage lang={lang} /></Shell>} />
      <Route path={`${seg.programs}/:slug`} element={<Shell lang={lang}><ProgramDetail lang={lang} /></Shell>} />
      <Route path={seg.mentalHealth} element={<Shell lang={lang}><MentalHealthPage lang={lang} /></Shell>} />
      <Route path={`${seg.mentalHealth}/:slug`} element={<Shell lang={lang}><TopicDetail lang={lang} /></Shell>} />
      <Route path={seg.answers} element={<Shell lang={lang}><AnswersPage lang={lang} /></Shell>} />
      <Route path={`${seg.answers}/:slug`} element={<Shell lang={lang}><AnswerDetail lang={lang} /></Shell>} />
      <Route path={seg.faq} element={<Shell lang={lang}><FaqPage lang={lang} /></Shell>} />
      <Route path={seg.location} element={<Shell lang={lang}><LocationPage lang={lang} /></Shell>} />
      <Route path={seg.contact} element={<Shell lang={lang}><Contact lang={lang} /></Shell>} />
      <Route path={seg.booking} element={<Shell lang={lang}><Booking lang={lang} /></Shell>} />
      <Route path={seg.privacy} element={<Shell lang={lang}><Legal lang={lang} kind="privacy" /></Shell>} />
      <Route path={seg.terms} element={<Shell lang={lang}><Legal lang={lang} kind="terms" /></Shell>} />
      <Route path={seg.cancellation} element={<Shell lang={lang}><Legal lang={lang} kind="cancellation" /></Shell>} />
      {AREAS.map((a) => (
        <Route key={a.key} path={a.slug[lang]} element={<Shell lang={lang}><AreaPage lang={lang} areaKey={a.key} /></Shell>} />
      ))}
      {lang === "en" && (
        <Route path="psychologist-for-expats-bali" element={<Shell lang="en"><Expats /></Shell>} />
      )}
    </>
  );
};
